import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({
  children,
  role
}) {

  const userRole =
    localStorage.getItem(
      "userRole"
    );

  const adminToken =
    localStorage.getItem(
      "adminToken"
    );

  const ownerToken =
    localStorage.getItem(
      "ownerToken"
    );

  /*
  CHECK LOGIN
  */

  if (role === "admin") {

    if (
      !adminToken ||
      userRole !== "admin"
    ) {

      return (
        <Navigate
          to="/admin-login"
          replace
        />
      );

    }

  }

  if (role === "owner") {

    if (
      !ownerToken ||
      userRole !== "owner"
    ) {

      return (
        <Navigate
          to="/owner-login"
          replace
        />
      );

    }

  }

  return children;

}